<template>
  <div class="scroll-section">
    <header class="team-header">
      <h1 v-html="$t('team.team_header')"></h1>
    </header>
    <div class="container">
      <div class="team-columns columns">
        <div class="pcb-bg">
          <svg viewBox="0 0 2260 903" xmlns="http://www.w3.org/2000/svg">
            <defs></defs>
            <title>pcb-pathsAsset 5</title>
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <ellipse
                  id="Ring"
                  class="cls-1"
                  cx="1452.86"
                  cy="289.83"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-2"
                  class="cls-1"
                  cx="814.43"
                  cy="272.47"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-3"
                  class="cls-1"
                  cx="814.43"
                  cy="48.91"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-4"
                  class="cls-1"
                  cx="710.24"
                  cy="9.98"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-5"
                  class="cls-1"
                  cx="608.07"
                  cy="81.12"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-6"
                  class="cls-1"
                  cx="1452.86"
                  cy="69.07"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-7"
                  class="cls-1"
                  cx="764.78"
                  cy="324.08"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-8"
                  class="cls-1"
                  cx="701.92"
                  cy="220.48"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-9"
                  class="cls-1"
                  cx="945.48"
                  cy="190.07"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-10"
                  class="cls-1"
                  cx="1340.47"
                  cy="190.04"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-11"
                  class="cls-1"
                  cx="1521.14"
                  cy="324.07"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-12"
                  class="cls-1"
                  cx="1740.09"
                  cy="360.39"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-13"
                  class="cls-1"
                  cx="1840.34"
                  cy="494.49"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-14"
                  class="cls-1"
                  cx="2024.81"
                  cy="511.54"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-15"
                  class="cls-1"
                  cx="2184.78"
                  cy="413.02"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-16"
                  class="cls-1"
                  cx="2167.95"
                  cy="584.86"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-17"
                  class="cls-1"
                  cx="2250.43"
                  cy="603.28"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-18"
                  class="cls-1"
                  cx="2229.82"
                  cy="696.54"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-19"
                  class="cls-1"
                  cx="1877.73"
                  cy="603.28"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-20"
                  class="cls-1"
                  cx="1649.36"
                  cy="792.63"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-21"
                  class="cls-1"
                  cx="1573.73"
                  cy="741.9"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-22"
                  class="cls-1"
                  cx="712.26"
                  cy="741.75"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-23"
                  class="cls-1"
                  cx="636.71"
                  cy="792.75"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-24"
                  class="cls-1"
                  cx="408"
                  cy="603.05"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-25"
                  class="cls-1"
                  cx="261.1"
                  cy="511.63"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-26"
                  class="cls-1"
                  cx="85.62"
                  cy="584.75"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-27"
                  class="cls-1"
                  cx="18.18"
                  cy="603.05"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-28"
                  class="cls-1"
                  cx="9.57"
                  cy="454.04"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-29"
                  class="cls-1"
                  cx="298.77"
                  cy="488.98"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-30"
                  class="cls-1"
                  cx="445.69"
                  cy="494.73"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-31"
                  class="cls-1"
                  cx="546.11"
                  cy="360.05"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-32"
                  class="cls-1"
                  cx="228.11"
                  cy="296.46"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-33"
                  class="cls-1"
                  cx="2057.86"
                  cy="296.64"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-34"
                  class="cls-1"
                  cx="1766.22"
                  cy="37.71"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-35"
                  class="cls-1"
                  cx="2109.88"
                  cy="329.88"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-36"
                  class="cls-1"
                  cx="1583.76"
                  cy="220.17"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <polyline
                  id="track"
                  class="cls-1"
                  points="1674.18 564.64 1858.05 564.64 1877.73 543.52 1991.39 543.52 2030.43 584.86 2161.57 584.86"
                />
                <polyline
                  id="track-2"
                  class="cls-1"
                  data-name="track"
                  points="1660.32 514.89 1910.86 514.89 1968.28 454.09 2103.94 454.09 2124.39 475.74 2124.39 490.01 2104.11 511.49 2031.87 511.54"
                />
                <line
                  id="track-3"
                  class="cls-1"
                  data-name="track"
                  x1="1663.02"
                  x2="1833.27"
                  y1="494.49"
                  y2="494.49"
                />
                <polyline
                  id="track-4"
                  class="cls-1"
                  data-name="track"
                  points="1663.03 474.89 1827.38 474.89 1885.81 413.01 2178.22 413.01"
                />
                <line
                  id="track-5"
                  class="cls-1"
                  data-name="track"
                  x1="1652.21"
                  x2="1734.96"
                  y1="452.34"
                  y2="365.53"
                />
                <polyline
                  id="track-6"
                  class="cls-1"
                  data-name="track"
                  points="1675.28 468.99 1769.77 368.92 2136.56 368.92 2159.91 344.2 2159.91 324.47 2134.08 297.12 2064.93 297.12"
                />
                <polyline
                  id="track-7"
                  class="cls-1"
                  data-name="track"
                  points="1635.98 432.21 1761.4 299.4 1809 299.4 1837.99 330.1 2103.94 330.1"
                />
                <ellipse
                  id="Ring-37"
                  class="cls-1"
                  cx="227.98"
                  cy="296.23"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-38"
                  class="cls-1"
                  cx="175.96"
                  cy="329.48"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <line
                  id="track-8"
                  class="cls-1"
                  data-name="track"
                  x1="633.63"
                  x2="550.88"
                  y1="451.94"
                  y2="365.12"
                />
                <polyline
                  id="track-9"
                  class="cls-1"
                  data-name="track"
                  points="610.56 468.58 516.07 368.52 149.28 368.52 125.93 343.8 125.93 324.07 151.76 296.72 220.91 296.72"
                />
                <polyline
                  id="track-10"
                  class="cls-1"
                  data-name="track"
                  points="649.85 431.81 524.43 298.99 476.84 298.99 447.85 329.7 181.89 329.7"
                />
                <polyline
                  id="track-11"
                  class="cls-1"
                  data-name="track"
                  points="1457.86 465.36 1383.12 465.36 1325.13 403.95 1161.27 403.75"
                />
                <polyline
                  id="track-12"
                  class="cls-1"
                  data-name="track"
                  points="1099.24 403.75 961.09 403.75 902.93 465.34 813.29 465.34"
                />
                <polyline
                  id="track-13"
                  class="cls-1"
                  data-name="track"
                  points="1055.09 425.94 967.51 425.94 909.43 487.44 827.96 487.33"
                />
                <polyline
                  id="track-14"
                  class="cls-1"
                  data-name="track"
                  points="834.55 507.17 953.95 507.17 1011.82 445.89 1033.8 445.81"
                />
                <polyline
                  id="track-15"
                  class="cls-1"
                  data-name="track"
                  points="1207.32 425.94 1318.27 425.94 1376.19 487.29 1440.03 487.29"
                />
                <polyline
                  id="track-16"
                  class="cls-1"
                  data-name="track"
                  points="1437.33 507.17 1331.53 507.17 1273.72 445.95 1222.27 445.81"
                />
                <line
                  id="track-17"
                  class="cls-1"
                  data-name="track"
                  x1="841.52"
                  x2="994.8"
                  y1="535.76"
                  y2="535.76"
                />
                <polyline
                  id="track-18"
                  class="cls-1"
                  data-name="track"
                  points="827.83 573.95 932.87 573.95 953.23 552.39 1004.9 552.39"
                />
                <polyline
                  id="track-19"
                  class="cls-1"
                  data-name="track"
                  points="1258.46 552.47 1332.55 552.47 1352.86 573.98 1443.49 573.95"
                />
                <polyline
                  id="track-20"
                  class="cls-1"
                  data-name="track"
                  points="1446.43 597.84 1376.15 597.84 1317.97 659.45 1192.81 659.45"
                />
                <polyline
                  id="track-21"
                  class="cls-1"
                  data-name="track"
                  points="1063.84 659.18 967.38 659.18 909.52 597.9 817.82 597.84"
                />
                <polyline
                  id="track-22"
                  class="cls-1"
                  data-name="track"
                  points="819.84 606.43 935.97 729.4 1349.82 729.4 1455.1 617.91"
                />
                <polyline
                  id="track-23"
                  class="cls-1"
                  data-name="track"
                  points="1470.45 444.02 1426.44 397.41 1391.42 397.41 1294.82 295.12 990.64 295.12 894.16 397.29 859.58 397.29 805.03 455.05"
                />
                <line
                  id="track-24"
                  class="cls-1"
                  data-name="track"
                  x1="701.92"
                  x2="701.92"
                  y1="227.97"
                  y2="412.08"
                />
                <line
                  id="track-25"
                  class="cls-1"
                  data-name="track"
                  x1="636.71"
                  x2="636.71"
                  y1="785.26"
                  y2="659.31"
                />
                <line
                  id="track-26"
                  class="cls-1"
                  data-name="track"
                  x1="712.26"
                  x2="712.26"
                  y1="734.27"
                  y2="668.98"
                />
                <line
                  id="track-27"
                  class="cls-1"
                  data-name="track"
                  x1="452.75"
                  x2="589.03"
                  y1="494.73"
                  y2="494.73"
                />
                <line
                  id="track-28"
                  class="cls-1"
                  data-name="track"
                  x1="1521.14"
                  x2="1521.14"
                  y1="331.55"
                  y2="420.58"
                />
                <line
                  id="track-29"
                  class="cls-1"
                  data-name="track"
                  x1="1583.76"
                  x2="1583.76"
                  y1="227.66"
                  y2="413.02"
                />
                <line
                  id="track-30"
                  class="cls-1"
                  data-name="track"
                  x1="764.78"
                  x2="764.78"
                  y1="331.57"
                  y2="424.69"
                />
                <line
                  id="track-31"
                  class="cls-1"
                  data-name="track"
                  x1="1573.73"
                  x2="1573.73"
                  y1="734.41"
                  y2="663.43"
                />
                <line
                  id="track-32"
                  class="cls-1"
                  data-name="track"
                  x1="1649.36"
                  x2="1649.36"
                  y1="785.15"
                  y2="623.52"
                />
                <line
                  id="track-33"
                  class="cls-1"
                  data-name="track"
                  x1="1452.86"
                  x2="1452.86"
                  y1="282.35"
                  y2="75.5"
                />
                <ellipse
                  id="Ring-39"
                  class="cls-1"
                  cx="1471.63"
                  cy="272.58"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-40"
                  class="cls-1"
                  cx="1471.63"
                  cy="51.81"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <line
                  id="track-34"
                  class="cls-1"
                  data-name="track"
                  x1="1471.63"
                  x2="1471.63"
                  y1="265.09"
                  y2="58.24"
                />
                <line
                  id="track-35"
                  class="cls-1"
                  data-name="track"
                  x1="814.43"
                  x2="814.43"
                  y1="264.99"
                  y2="56.39"
                />
                <ellipse
                  id="Ring-41"
                  class="cls-1"
                  cx="833.03"
                  cy="290.17"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <ellipse
                  id="Ring-42"
                  class="cls-1"
                  cx="833.03"
                  cy="66.61"
                  data-name="Ring"
                  rx="7.07"
                  ry="7.48"
                />
                <line
                  id="track-36"
                  class="cls-1"
                  data-name="track"
                  x1="833.03"
                  x2="833.03"
                  y1="282.69"
                  y2="74.09"
                />
                <polyline
                  id="track-37"
                  class="cls-1"
                  data-name="track"
                  points="659.34 417 659.34 355.17 638.89 333.51 638.89 198.8 608.07 166.16 608.07 88.6"
                />
                <polyline
                  id="track-38"
                  class="cls-1"
                  data-name="track"
                  points="681.12 415.97 681.12 199 710.24 168.16 710.24 17.46"
                />
                <polyline
                  id="track-39"
                  class="cls-1"
                  data-name="track"
                  points="729.3 420.93 729.3 279.95 787.46 218.37 787.46 29.19 810.01 5.3 841.35 5.3 862.93 28.16 862.93 317.4 792.44 392.05 792.44 442.23"
                />
                <polyline
                  id="track-40"
                  class="cls-1"
                  data-name="track"
                  points="1556.11 420.93 1556.11 279.95 1497.98 218.37 1497.98 29.19 1475.44 5.3 1444.11 5.3 1422.54 28.16 1422.54 317.4 1493 392.05 1493 442.23"
                />
                <line
                  id="track-41"
                  class="cls-1"
                  data-name="track"
                  x1="1246.27"
                  x2="1438.59"
                  y1="535.76"
                  y2="535.76"
                />
                <polyline
                  id="track-42"
                  class="cls-1"
                  data-name="track"
                  points="1603.54 434.56 1603.54 198.53 1575.14 168.46 1575.14 13.44"
                />
                <polyline
                  id="track-43"
                  class="cls-1"
                  data-name="track"
                  points="1626.22 424.96 1626.22 355.43 1646.76 333.69 1646.76 198.75 1677.54 166.16 1677.54 54.96 1692.76 38.84 1716.09 38.84 1731.47 55.13 1731.47 207.79 1784.28 263.71 2197.48 263.71 2208.8 251.72 2208.8 235.35 2197.36 223.23 1823.24 223.23 1766.09 162.72 1766.09 45.29"
                />
                <polyline
                  id="track-44"
                  class="cls-1"
                  data-name="track"
                  points="599.43 474.36 457.97 474.36 399.67 412.61 125.93 412.61 82.95 367.1 82.95 272.47 132.64 219.85 467.86 219.85 520.37 164.25 520.37 41.42"
                />
                <polyline
                  id="track-45"
                  class="cls-1"
                  data-name="track"
                  points="181.91 263.99 500.31 263.99 554.73 206.36 554.73 147.12"
                />
                <polyline
                  id="track-46"
                  class="cls-1"
                  data-name="track"
                  points="914.78 28.47 914.78 192.22 970.42 251.14 1314.8 251.14 1370.63 192.02 1370.63 28.47"
                />
                <line
                  id="track-47"
                  class="cls-1"
                  data-name="track"
                  x1="945.48"
                  x2="945.48"
                  y1="182.59"
                  y2="13.44"
                />
                <line
                  id="track-48"
                  class="cls-1"
                  data-name="track"
                  x1="1340.47"
                  x2="1340.47"
                  y1="182.56"
                  y2="13.44"
                />
                <polyline
                  id="track-49"
                  class="cls-1"
                  data-name="track"
                  points="1671.47 598.64 1794.17 598.64 1886.61 696.54 2222.75 696.54"
                />
                <polyline
                  id="track-50"
                  class="cls-1"
                  data-name="track"
                  points="1674.33 604.95 1747.47 682.41 1779.42 682.41 1842.5 749.2 2158.95 749.2"
                />
                <line
                  id="track-51"
                  class="cls-1"
                  data-name="track"
                  x1="1884.79"
                  x2="2243.37"
                  y1="603.28"
                  y2="603.28"
                />
                <polyline
                  id="track-52"
                  class="cls-1"
                  data-name="track"
                  points="587.38 564.69 428.19 564.69 407.65 542.94 294.59 542.94 255.11 584.75 92.68 584.75"
                />
                <polyline
                  id="track-53"
                  class="cls-1"
                  data-name="track"
                  points="587.38 515.25 375.59 515.25 317.79 454.04 16.63 454.04"
                />
                <line
                  id="track-54"
                  class="cls-1"
                  data-name="track"
                  x1="400.94"
                  x2="25.25"
                  y1="603.05"
                  y2="603.05"
                />
                <polyline
                  id="track-55"
                  class="cls-1"
                  data-name="track"
                  points="587.38 598.64 491.86 598.64 398.65 697.34 92.68 697.34"
                />
                <polyline
                  id="track-56"
                  class="cls-1"
                  data-name="track"
                  points="597.14 619.58 538.33 681.86 506.56 681.86 443.27 748.88 43.86 748.88"
                />
                <polyline
                  id="track-57"
                  class="cls-1"
                  data-name="track"
                  points="1618.75 653.41 1618.75 801.05 1676.97 862.7 1676.97 903"
                />
                <line
                  id="track-58"
                  class="cls-1"
                  data-name="track"
                  x1="1594.75"
                  x2="1594.75"
                  y1="667.19"
                  y2="903"
                />
                <polyline
                  id="track-59"
                  class="cls-1"
                  data-name="track"
                  points="1519.21 656.09 1519.21 715.68 1548.27 746.47 1548.27 903"
                />
                <polyline
                  id="track-60"
                  class="cls-1"
                  data-name="track"
                  points="1489.63 643.92 1489.63 723.38 1519.21 754.7 1519.21 903"
                />
                <polyline
                  id="track-61"
                  class="cls-1"
                  data-name="track"
                  points="1472.06 638.37 1472.06 724.1 1353.71 849.41 1353.71 903"
                />
                <line
                  id="track-62"
                  class="cls-1"
                  data-name="track"
                  x1="691.28"
                  x2="691.28"
                  y1="676.67"
                  y2="903"
                />
                <polyline
                  id="track-63"
                  class="cls-1"
                  data-name="track"
                  points="666.6 664.68 666.6 801.41 608.55 862.88 608.55 903"
                />
                <polyline
                  id="track-64"
                  class="cls-1"
                  data-name="track"
                  points="766.23 662.26 766.23 715.95 737.2 746.69 737.2 903"
                />
                <polyline
                  id="track-65"
                  class="cls-1"
                  data-name="track"
                  points="795.76 641.73 795.76 723.87 766.86 754.48 766.86 903"
                />
                <polyline
                  id="track-66"
                  class="cls-1"
                  data-name="track"
                  points="1671.47 619.99 1671.47 738.77 1730.1 800.85 1730.1 903"
                />
                <polyline
                  id="track-67"
                  class="cls-1"
                  data-name="track"
                  points="613.71 638.01 613.71 738.95 555.32 800.78 555.32 903"
                />
              </g>
            </g>
          </svg>
          <div class="pcb-dots">
            <div class="pcb-dot _1"></div>
            <div class="pcb-dot _2"></div>
            <div class="pcb-dot _3"></div>
            <div class="pcb-dot _4"></div>
            <div class="pcb-dot _5"></div>
            <div class="pcb-dot _6"></div>
            <div class="pcb-dot _7"></div>
            <div class="pcb-dot _8"></div>
            <div class="pcb-dot _9"></div>
            <div class="pcb-dot _10"></div>
            <div class="pcb-dot _11"></div>
          </div>
          <div class="overlay-gradient"></div>
        </div>
        <div v-for="(member, idx) in team.core" :key="idx" class="column">
          <div :class="'_' + idx" class="member-avatar">
            <div :class="'_' + idx" class="outer-glow"></div>
            <div :class="'_' + idx" class="outer-glow-2"></div>
            <div class="img-wrapper">
              <div :class="'_' + idx" class="bg-glow"></div>
              <img :class="'_' + idx" :src="member.avatar" class="team-img" />
            </div>
          </div>
          <div class="member-details">
            <header>
              <h4>
                <strong>{{ member.full_name }}</strong>
              </h4>
              <h3 v-html="$t('team.core_team[' + idx + '].title')"></h3>
            </header>
            <div v-html="$t('team.core_team[' + idx + '].desc')"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="other-members">
      <header class="others-header">
        <h1>{{ $t("team.others_header") }}</h1>
      </header>
      <div class="other-members-wrapper">
        <div
          v-for="(member, idx) in team.others"
          v-if="member.show !== false && memberHasImage(idx)"
          :key="idx"
          :class="memberClass(idx)"
          :style="getSlideStyles(member.active)"
          class="members-bubble-small"
        >
          <div
            :class="{ 'is-hover': member.active }"
            class="member-avatar-wrapper animate"
            @mouseenter="showMemberPopover($event, member)"
            @mouseleave="hideMemberPopover($event, member)"
          >
            <div class="rounded-image-wrapper">
              <!--
              <img src="../.././assets/240x240.png">
              -->
              <img :src="memberImage(idx)" />
            </div>
          </div>
          <transition :css="false" @enter="enterPopover" @leave="leavePopover">
            <div
              v-show="member.active"
              :style="'bottom: ' + member.offset + 'px'"
              class="info-popover"
            >
              <div class="info-popover-bg"></div>
              <div class="info-popover-content">
                <header class="info-popover-header">
                  <h6>
                    <strong>{{ memberName(idx) }}</strong>
                  </h6>
                  <h5>{{ memberTitle(idx) }}</h5>
                </header>
                <div class="info-popover-desc" v-html="memberDesc(idx)"></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="join-the-team">
      <div class="jtt-inner">
        <h1>
          <strong>{{ $t("team.join_team") }}</strong>
        </h1>
        <div class="get-in-touch">
          <h4>{{ $t("team.get_in_touch") }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgThomas from "../../assets/avatars/th.png";
import imgMartin from "../../assets/avatars/mp.png";
import imgBirol from "../../assets/avatars/ba.png";
import { mapGetters, mapActions } from "vuex";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";
import TweenMax from "gsap/TweenMax";
import TimelineMax from "gsap/TimelineMax";

import image_ba from "../../assets/members/BA_250x250px-BW.png";
import image_jwl from "../../assets/members/jwl.png";
import image_es from "../../assets/members/es.png";
import image_mp from "../../assets/members/MP_250x250px-BW.png";
import image_mr from "../../assets/members/mr.jpg";
import image_nc from "../../assets/members/nc.png";
import image_ms from "../../assets/members/MS_250x250px-BW.png";
import image_th from "../../assets/members/TH_250x250px-BW.png";
import image_mk from "../../assets/members/MK_250x250px-BW.png";
import image_jbp from "../../assets/members/jbp.png";
import image_jj from "../../assets/members/jack.png";

import image_mc from "../../assets/members/mc.png";
import image_tl from "../../assets/members/tl.png";

import image_sk from "../../assets/members/SK_250x250px-BW.png";
import image_mb from "../../assets/members/MB_250x250px-BW.png";
import image_np from "../../assets/members/NP_250x250px-BW.png";
import image_jgo from "../../assets/members/JGO_250x250px-BW.png";
import image_os from "../../assets/members/OS_250x250px-BW.png";
import image_og from "../../assets/members/OG_250x250px-BW.png";
import image_mf from "../../assets/members/mf.png";
import image_sro from "../../assets/members/sro.png";
import image_ma from "../../assets/members/ma.jpg";
import image_tf from "../../assets/members/tf.jpg";
import image_mph from "../../assets/members/mph.png";
import image_her from "../../assets/members/her.png";
import image_bp from "../../assets/members/bp.png";
import image_ak from "../../assets/members/ak.png";
import image_maj from "../../assets/members/MAJ_2023_250x250px-BW.png";
import image_jl from "../../assets/members/JL_250x250px-BW.png";
import image_mlc from "../../assets/members/MLC_250x250px-BW.png";
import image_kdl from "../../assets/members/KDL_250x250px-BW.png";
import image_kah from "../../assets/members/KAH_250x250px-BW.png";
import image_thl from "../../assets/members/THL_250x250px-BW.png";
import image_klh from "../../assets/members/KLH_250x250px-BW.png";
import image_few from "../../assets/members/FEW_2024_250x250px-BW.png";
import image_guc from "../../assets/members/GUC_2023_250x250px-BW.png";
import image_mmj from "../../assets/members/MMJ-250x250px-BW-2025.png";
import image_vam from "../../assets/members/VAM-250x250px-BW-2025.png";
import image_sbk from "../../assets/members/SBK-250x250px-BW.png";
import image_sis from "../../assets/members/SIS-250x250px-BW.png";
import image_rbe from "../../assets/members/RBE-250x250px-BW-2025.png";
import image_oa from "../../assets/members/OA-250x250px-BW.png";
import image_mmp from "../../assets/members/MMP-250x250px-BW.png";
import image_fallback from "../../assets/android-chrome-144x144.png";
import { isElementVisible } from "../../useElementVisible.js";

const member_info = [
  // row 1
  { id: "sk", image: image_sk, class: "member-info-sk" },
  { id: "kdl", image: image_kdl, class: "member-info-kdl" },
  { id: "mb", image: image_mb, class: "member-info-mb" },
  { id: "np", image: image_np, class: "member-info-np" },
  { id: "oa", image: image_oa, class: "member-info-oa" },
  { id: "kah", image: image_kah, class: "member-info-kah" },
  { id: "klh", image: image_klh, class: "member-info-klh" },

  // row 2
  { id: "mr", image: image_mr, class: "member-info-mr" },
  { id: "mk", image: image_mk, class: "member-info-mk" },
  { id: "mp", image: image_mp, class: "member-info-mp" },
  { id: "ba", image: image_ba, class: "member-info-ba" },
  { id: "th", image: image_th, class: "member-info-th" },
  { id: "thl", image: image_thl, class: "member-info-thl" },
  { id: "jwl", image: image_jwl, class: "member-info-jwl" },
  { id: "mc", image: image_mc, class: "member-info-mc" },

  // row 3
  { id: "ms", image: image_ms, class: "member-info-ms" },
  { id: "nc", image: image_nc, class: "member-info-nc" },
  { id: "jbp", image: image_jbp, class: "member-info-jbp" },
  { id: "jl", image: image_jl, class: "member-info-jl" },
  { id: "mf", image: image_mf, class: "member-info-mf" },
  { id: "os", image: image_os, class: "member-info-os" },
  { id: "es", image: image_es, class: "member-info-es" },
  { id: "jj", image: image_jj, class: "member-info-jj" },

  // row 4
  { id: "ma", image: image_ma, class: "member-info-ma" },
  { id: "mlc", image: image_mlc, class: "member-info-mlc" },
  { id: "tl", image: image_tl, class: "member-info-tl" },
  { id: "tf", image: image_tf, class: "member-info-tf" },
  { id: "og", image: image_og, class: "member-info-og" },
  { id: "mph", image: image_mph, class: "member-info-mph" },

  // row 5
  { id: "maj", image: image_maj, class: "member-info-maj" },
  { id: "her", image: image_her, class: "member-info-her" },
  { id: "bp", image: image_bp, class: "member-info-bp" },
  { id: "ak", image: image_ak, class: "member-info-ak" },
  { id: "mmp", image: image_mmp, class: "member-info-mmp" },
  { id: "few", image: image_few, class: "member-info-few" },
  { id: "guc", image: image_guc, class: "member-info-guc" },
  { id: "mmj", image: image_mmj, class: "member-info-mmj" },
  { id: "rbe", image: image_rbe, class: "member-info-rbe" },
  { id: "vam", image: image_vam, class: "member-info-vam" },
  { id: "sbk", image: image_sbk, class: "member-info-sbk" },
  { id: "sis", image: image_sis, class: "member-info-sis" },
];

let others = member_info.map((member) => {
  return {
    isHover: false,
    active: false,
    offset: 0,
    closestTo: "",
  };
});

export default {
  name: "Team",
  data() {
    return {
      exclude_from_nav: false,
      nav_title: "crew",
      animationsDone: false,
      animationsInit: false,
      bubbleAnimationsInit: false,
      timelines: {
        dot1Tl: null,
        dot2Tl: null,
      },
      team_bubbles: {
        max_size: 120,
        min_size: 60,
      },
      team: {
        core: [
          {
            avatar: imgBirol,
            full_name: "Birol Altinok",
          },
          {
            avatar: imgMartin,
            full_name: "Martin Pløger",
          },
          {
            avatar: imgThomas,
            full_name: "Thomas Hofmann",
          },
        ],
        // should be moved to its own component, passed as props in hover functions
        others: others,
      },
    };
  },
  mounted() {
    this.hideElements();

    isElementVisible(this.$el, () => {
      this.runSectionAnimations();
      this.runBubbleAnimations();
    }).attachDefaultEvents();
  },
  watch: {
    active_section_name(val) {
      if (val === this.$options._componentTag) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations();
        }
      }
    },
    scroll_pos(val) {
      if (
        this.scroll_pos > this.$el.offsetTop - 150 &&
        this.scroll_pos < this.elHeight - 200 + this.$el.offsetTop
      ) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations();
          this.setActiveSection(this.$options._componentTag);
        }
      }
      if (
        this.scroll_pos > this.$el.offsetTop + 700 &&
        this.scroll_pos < this.elHeight - 10 + this.$el.offsetTop
      ) {
        if (!this.is_animating_scroll) {
          this.runBubbleAnimations();
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      active_section_name: "getActiveSectionName",
      scroll_pos: "getScrollPos",
      is_animating_scroll: "getAnimatingScrollState",
    }),
    elHeight() {
      return Math.ceil(this.$el.getBoundingClientRect().height);
    },
    numOfMembers() {
      return this.team.others.length;
    },
  },
  methods: {
    ...mapActions(["setActiveSection"]),
    memberHasImage(idx) {
      return member_info[idx] && member_info[idx].image;
    },
    memberImage(idx) {
      if (member_info[idx]) {
        return member_info[idx].image;
      } else {
        return image_fallback;
      }
    },
    memberClass(idx) {
      if (member_info[idx]) {
        return member_info[idx].class;
      } else {
        return "";
      }
    },
    memberName(idx) {
      if (member_info[idx]) {
        return this.$t("team.other_members")[member_info[idx].id].name;
      } else {
        return "";
      }
    },
    memberTitle(idx) {
      if (member_info[idx]) {
        return this.$t("team.other_members")[member_info[idx].id].title;
        //return this.$t('team.other_members[' + member_info[idx].id + '].title');
      } else {
        return "";
      }
    },
    memberDesc(idx) {
      if (member_info[idx]) {
        return this.$t("team.other_members")[member_info[idx].id].desc;
        //return this.$t('team.other_members[' + member_info[idx].id + '].desc');
      } else {
        return "";
      }
    },
    hideElements() {
      if (window.ieLegacy()) {
        return;
      }
      let elements = this.$el.querySelectorAll(".animate");
      TweenMax.set(elements, {
        autoAlpha: 0,
      });
      let bg = this.$el.querySelector(".pcb-bg");
      TweenMax.set(bg, {
        autoAlpha: 0,
      });
      /*
      let memberImgs = this.$el.querySelectorAll('.team-img')
      TweenMax.set(memberImgs, {
          y: 60,
          autoAlpha: 0
      })*/
    },
    getSlideStyles(active) {
      return {
        "z-index": active ? 2 : 1,
      };
    },
    runBubbleAnimations() {
      if (window.ieLegacy()) {
        return;
      }
      if (this.bubbleAnimationsInit) return;
      let elements = this.$el.querySelectorAll(".animate");
      let hoverBubbles = new TimelineMax({ repeat: 0 });
      hoverBubbles.staggerFromTo(
        elements,
        0.3,
        {
          scale: 0.5,
          autoAlpha: 0,
        },
        {
          scale: 0.9,
          autoAlpha: 1,
          ease: Power1.easeInOut,
        },
        Math.random() * (0.1 - 0.05) + 0.05
      );
      this.bubbleAnimationsInit = true;
    },
    runSectionAnimations() {
      if (this.animationsDone || this.animationsInit) return;

      let bg = this.$el.querySelector(".pcb-bg");
      let memberImg = this.$el.querySelectorAll(".team-img");
      TweenMax.to(bg, 0.5, {
        autoAlpha: 1,
        //ease: Power3.easeIn
      });
      TweenMax.staggerTo(
        memberImg,
        0.4,
        {
          autoAlpha: 1,
        },
        0.1
      );

      /*
      TweenMax.staggerFromTo(memberImg, 1.2, {
          y: 60
      }, {
          y: 0,
          ease: Elastic.easeInOut
      }, 0.2);*/

      // PCB animations
      let t22 = this.$el.querySelector("#track-22");
      let jacobToThomas = MorphSVGPlugin.pathDataToBezier(t22);
      let t23 = this.$el.querySelector("#track-23");
      let thomasToJacob = MorphSVGPlugin.pathDataToBezier(t23);
      let t20 = this.$el.querySelector("#track-20");
      let thomasToHans = MorphSVGPlugin.pathDataToBezier(t20);
      let t15 = this.$el.querySelector("#track-15");
      let hansToThomas = MorphSVGPlugin.pathDataToBezier(t15);
      let t13 = this.$el.querySelector("#track-13");
      let jacobToHans = MorphSVGPlugin.pathDataToBezier(t13);
      let t14 = this.$el.querySelector("#track-14");
      let t14a = MorphSVGPlugin.pathDataToBezier(t14);
      let t16 = this.$el.querySelector("#track-16");
      let t16a = MorphSVGPlugin.pathDataToBezier(t16);
      let t21 = this.$el.querySelector("#track-21");
      let t21a = MorphSVGPlugin.pathDataToBezier(t21);
      let t39 = this.$el.querySelector("#track-39");
      let t39a = MorphSVGPlugin.pathDataToBezier(t39);
      let t43 = this.$el.querySelector("#track-43");
      let t43a = MorphSVGPlugin.pathDataToBezier(t43);
      let t44 = this.$el.querySelector("#track-44");
      let t44a = MorphSVGPlugin.pathDataToBezier(t44);

      let dot1 = this.$el.querySelector(".pcb-dot._1");
      let dot2 = this.$el.querySelector(".pcb-dot._2");
      let dot3 = this.$el.querySelector(".pcb-dot._3");
      let dot4 = this.$el.querySelector(".pcb-dot._4");
      let dot5 = this.$el.querySelector(".pcb-dot._5");
      let dot6 = this.$el.querySelector(".pcb-dot._6");
      let dot7 = this.$el.querySelector(".pcb-dot._7");
      let dot8 = this.$el.querySelector(".pcb-dot._8");
      let dot9 = this.$el.querySelector(".pcb-dot._9");
      let dot10 = this.$el.querySelector(".pcb-dot._10");
      let dot11 = this.$el.querySelector(".pcb-dot._11");

      TweenMax.to(dot1, 2.9, {
        bezier: {
          values: jacobToThomas,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot2, 2.5, {
        bezier: {
          values: thomasToJacob,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot3, 1.7, {
        bezier: {
          values: thomasToHans,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
        delay: 1,
      });
      TweenMax.to(dot4, 1.9, {
        bezier: {
          values: hansToThomas,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
        delay: 0.3,
      });
      TweenMax.to(dot5, 1.6, {
        bezier: {
          values: jacobToHans,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
        delay: 0.3,
      });
      TweenMax.to(dot6, 1.8, {
        bezier: {
          values: t14a,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot7, 1.1, {
        bezier: {
          values: t16a,
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot8, 1.4, {
        bezier: {
          values: t21a.reverse(),
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot9, 4, {
        bezier: {
          values: t39a.reverse(),
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot10, 4, {
        bezier: {
          values: t43a.reverse(),
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });
      TweenMax.to(dot11, 4, {
        bezier: {
          values: t44a.reverse(),
          type: "cubic",
        },
        ease: Power1.easeInOut,
        repeat: -1,
      });

      this.animationsInit = true;
    },
    showMemberPopover($event, member) {
      let bubbleData = $event.target.getBoundingClientRect();
      if (bubbleData.left < 130) {
        member.closestTo = "left";
      }
      if (window.innerWidth < bubbleData.left + 184) {
        member.closestTo = "right";
      }
      member.isHover = true;
      member.offset = $event.target.offsetHeight;
      setTimeout(() => {
        if (member.isHover) {
          member.active = true;
        }
      }, 300);
    },
    hideMemberPopover($event, member) {
      member.active = false;
      member.isHover = false;
    },
    enterPopover(el, done) {
      // set initial state to animate from
      TweenMax.set(el, {
        autoAlpha: 0,
      });
      TweenMax.to(el, 0.15, {
        autoAlpha: 1,
        ease: Sine.easeIn,
      });
      TweenMax.to(el, 0.5, {
        y: -28,
        ease: Expo.easeOut,
        onComplete: done(),
      });
    },
    leavePopover(el, done) {
      TweenMax.to(el, 0.1, {
        autoAlpha: 0,
        y: 0,
        ease: Sine.easeOut,
        onComplete: done(),
      });
    },
  },
};
</script>

<style lang="postcss">
.overlay-gradient {
  background: ease-out-sine-gradient(transparent, #ff7c4e);
}
</style>

<style lang="scss" scoped>
.cls-1 {
  fill: none;
  stroke: #e66c42;
  stroke-miterlimit: 10;
  stroke-width: 4px;
}

.scroll-section {
  position: relative;
  background-color: #ff7c4e;
  padding-top: 55px;
  padding-bottom: 80px;
  overflow: hidden;
}

.members-bubble-small {
  padding: 0;
  flex-basis: initial;
  position: absolute;
  left: 50%;
  cursor: pointer;

  $down_px: 80px;
  $bottom_left_px: -50px;

  // birol
  &.member-info-ba {
    width: 92px;
    height: 92px;
    transform: translate(-23px, 55px + $down_px);
  }

  // mathias bork
  &.member-info-mk {
    width: 94px;
    height: 94px;
    transform: translate(-244px, 27px + $down_px);
  }

  // jeppe w. larsen
  &.member-info-jwl {
    width: 88px;
    height: 88px;
    transform: translate(317px, 30px + $down_px);
  }

  // martin pløger
  &.member-info-mp {
    width: 87px;
    height: 87px;
    transform: translate(-132px, 42px + $down_px);
  }

  // morten riber
  &.member-info-mr {
    width: 88px;
    height: 88px;
    transform: translate(-352px, 18px + $down_px);
  }

  // thomas hofmann
  &.member-info-th {
    width: 88px;
    height: 88px;
    transform: translate(93px, 45px + $down_px);
  }

  // Mark Halkjær Christensen
  &.member-info-mc {
    width: 88px;
    height: 88px;
    transform: translate(428px, 24px + $down_px);
  }

  // Kenn Leth Hansen
  &.member-info-klh {
    width: 95px;
    height: 95px;
    transform: translate(460px, 0px);
  }

  // Steffen Kræmmer
  &.member-info-sk {
    width: 89px;
    height: 89px;
    transform: translate(-320px, 5px);
  }

  // Kenneth Darell Larsen
  &.member-info-kdl {
    width: 89px;
    height: 89px;
    transform: translate(-205px, 10px);
  }

  // Kasper Hermansen
  &.member-info-kah {
    width: 89px;
    height: 89px;
    transform: translate(245px, 5px);
  }

  // Mads Brogaard
  &.member-info-mb {
    width: 89px;
    height: 89px;
    transform: translate(-90px, 26px);
  }

  // Nadia Panzio
  &.member-info-np {
    width: 89px;
    height: 89px;
    transform: translate(25px, 25px);
  }

  // Ole Andersen
  &.member-info-oa {
    width: 89px;
    height: 89px;
    transform: translate(139px, 12px);
  }

  /******
   ROW 3
  ******/

  $row_3_left: -10px;
  $row_3_negative_left: -15px;
  $row_3_center_push: 0;
  $row_3_down: 85px;

  // lasse lysemose
  &.member-info-nc {
    width: 89px;
    height: 89px;
    transform: translate(-227px + $row_3_left, 142px + $row_3_down);
  }

  // morten skyt
  &.member-info-ms {
    width: 94px;
    height: 94px;
    transform: translate(-342px + $row_3_left, 127px + $row_3_down);
  }

  // jeppe bonneman. petersen
  &.member-info-jbp {
    width: 94px;
    height: 94px;
    transform: translate(-118px + $row_3_left, 150px + $row_3_down);
  }

  // Mette Fjeldhoff
  &.member-info-mf {
    width: 92px;
    height: 92px;
    transform: translate(114px + $row_3_negative_left, 150px + $row_3_down);
  }

  // Oliver Sigvardt
  &.member-info-os {
    width: 90px;
    height: 90px;
    transform: translate(224px + $row_3_negative_left, 156px + $row_3_down);
  }

  // esben sonne
  &.member-info-es {
    width: 93px;
    height: 93px;
    transform: translate(327px + $row_3_negative_left, 136px + $row_3_down);
  }

  // Jack Junge
  &.member-info-jj {
    width: 87px;
    height: 87px;
    transform: translate(440px + $row_3_negative_left, 135px + $row_3_down);
  }

  /******
   ROW 4
  ******/
  // Thomas hedelund larsen
  &.member-info-thl {
    width: 88px;
    height: 88px;
    transform: translate(258px + $bottom_left_px, 40px + $down_px);
  }

  // Mads Petersen
  &.member-info-mmp {
    width: 86px;
    height: 86px;
    transform: translate(-228px + $bottom_left_px, 246px + $down_px);
  }
  // Simon Sulek
  &.member-info-sis {
    width: 86px;
    height: 86px;
    transform: translate(-328px + $bottom_left_px, 246px + $down_px);
  }

  // Morten Andersen
  &.member-info-ma {
    width: 91px;
    height: 91px;
    transform: translate(-120px + $bottom_left_px, 258px + $down_px);
  }

  // Thor Thyeborg Lind
  &.member-info-tl {
    width: 91px;
    height: 91px;
    transform: translate(105px + $bottom_left_px, 262px + $down_px);
  }

  // Tobias Faucette
  &.member-info-tf {
    width: 88px;
    height: 88px;
    transform: translate(217px + $bottom_left_px, 257px + $down_px);
  }

  // Oliver Glozmann Bork Hansen
  &.member-info-og {
    width: 88px;
    height: 88px;
    transform: translate(326px + $bottom_left_px, 250px + $down_px);
  }

  // Madss Storm
  &.member-info-mph {
    width: 88px;
    height: 88px;
    transform: translate(435px + $bottom_left_px, 243px + $down_px);
  }
  // Sara Bech Kamph
  &.member-info-sbk {
    width: 88px;
    height: 88px;
    transform: translate(526px + $bottom_left_px, 250px + $down_px);
  }

  /******
 ROW 5
 ******/

  // Martin Laue Christensen
  &.member-info-mlc {
    width: 89px;
    height: 89px;
    transform: translate(-6px + $bottom_left_px, 264px + $down_px);
  }

  // Marco Jacobsen
  &.member-info-maj {
    width: 88px;
    height: 88px;
    transform: translate(-252px + $bottom_left_px, 353px + $down_px);
  }

  // Helena Rasmussen
  &.member-info-her {
    width: 88px;
    height: 88px;
    transform: translate(-150px + $bottom_left_px, 360px + $down_px);
  }

  // Bue Petersen
  &.member-info-bp {
    width: 88px;
    height: 88px;
    transform: translate(-50px + $bottom_left_px, 370px + $down_px);
  }

  // Anika Kristensen
  &.member-info-ak {
    width: 95px;
    height: 95px;
    transform: translate(350px, 0px);
  }

  // Jesper Lund
  &.member-info-jl {
    width: 88px;
    height: 88px;
    transform: translate(-2px + $row_3_left, 150px + $row_3_down);
  }

  // Frederik winther
  &.member-info-few {
    width: 88px;
    height: 88px;
    transform: translate(55px + $bottom_left_px, 370px + $down_px);
  }
  // Guc Chen
  &.member-info-guc {
    width: 88px;
    height: 88px;
    transform: translate(155px + $bottom_left_px, 370px + $down_px);
  }
  // Rune Bjerg Ens

  &.member-info-rbe {
    width: 88px;
    height: 88px;
    transform: translate(265px + $bottom_left_px, 370px + $down_px);
  }

  // Marcus Melgaard Jensen
  &.member-info-mmj {
    width: 88px;
    height: 88px;
    transform: translate(365px + $bottom_left_px, 370px + $down_px);
  }

  // Valdemar Mielke

  &.member-info-vam {
    width: 88px;
    height: 88px;
    transform: translate(465px + $bottom_left_px, 370px + $down_px);
  }

  //@media screen and (max-width: 768px) {
  //@media screen and (max-width: 1239px) {
  @media screen and (max-width: 1260px) {
    width: 80px !important;
    height: 80px !important;
    position: relative;
    left: auto;
    margin: 2%;
    transform: translate(0px) !important;
  }

  @media screen and (max-width: 916px) {
    width: 68px !important;
    height: 68px !important;
    margin: 1%;
    padding: 0;
  }

  @media screen and (max-width: 768px) {
    width: 60px !important;
    height: 60px !important;
    margin: 3%;
    padding: 0;
  }

  @media screen and (max-width: 360px) {
    width: 60px !important;
    height: 60px !important;
    margin: 3%;
    padding: 0;
  }
}
</style>

<style lang="scss">
.overlay-gradient {
  position: absolute;
  min-width: 1895px;
  width: 100%;
  height: 200px;
  left: 50%;
  bottom: 0;
  z-index: 1;
  transform: translateX(-50%);
}

.team-header {
  text-align: center;
  margin-bottom: 100px;
  position: relative;
  z-index: 2;

  > h1 {
    font-size: 5rem;
    text-transform: uppercase;

    @media screen and (max-width: 768px) {
      font-size: 2.3rem;
    }

    strong {
      color: #09227e;
    }

    span {
      color: white;
      font-weight: 300;
      text-transform: lowercase;
      font-family: "angelique_roseregular";
    }
  }
}

.team-columns {
  margin-top: 0;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 1024px) {
    padding: 0 2rem;
  }

  .column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    z-index: 2;
  }

  .pcb-bg {
    width: 2255px;
    display: block;
    position: absolute;
    left: 50%;
    top: -160px;
    transform: translate(-50%, -234px);
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: 1;
  }
}

.columns:last-child {
  margin-bottom: 0;
}

.member-avatar {
  width: 286px;
  height: 286px;
  border-radius: 50%;
  background-color: #c1552f;
  border: 16px solid #ff7c4e;
  position: relative;
  z-index: 2;
  margin-bottom: 0.5rem;
  overflow: visible;

  //-webkit-background-clip: padding-box;
  //background-clip: padding-box;

  &:after {
    content: "";
    display: block;
    width: 114%;
    height: 114%;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    position: absolute;
    z-index: -1;
    transform: translate(-50%, -50%);
    background-color: transparent;
    border: 4px solid #ee7146;
  }

  .img-wrapper {
    position: absolute;
    width: 254px;
    height: 254px;
    bottom: 0;
    //overflow: hidden !important;
    border-radius: 254px !important;
    -webkit-border-radius: 254px;
    border-top-left-radius: 254px;
    border-top-right-radius: 254px;
    border-bottom-left-radius: 254px;
    border-bottom-right-radius: 254px;
    text-align: center;
    display: block;
    //align-items: flex-end;
    //justify-content: center;
    backface-visibility: hidden;

    -webkit-background-clip: padding-box;
    background-clip: padding-box;

    z-index: 9997;

    img {
      backface-visibility: hidden;
      -webkit-border-radius: 254px;
      border-top-left-radius: 254px;
      border-top-right-radius: 254px;
      border-bottom-left-radius: 254px;
      border-bottom-right-radius: 254px;
      z-index: 9998;
    }
  }

  &._0 .img-wrapper > img {
    width: 220px;
    height: auto;
    display: block;
    position: absolute;
    left: 18px;
    top: auto;
    right: auto;
    bottom: -8px;
    transform: scaleX(-1) !important;
    border-bottom-left-radius: 254px;
    border-bottom-right-radius: 254px;
  }

  &._1 .img-wrapper > img {
    width: 242px;
    height: auto;
    display: block;
    position: absolute;
    left: 6px;
    top: auto;
    right: auto;
    bottom: 4px;
    border-bottom-left-radius: 254px;
    border-bottom-right-radius: 254px;
  }

  &._2 .img-wrapper > img {
    width: 196px;
    height: auto;
    display: block;
    position: absolute;
    left: auto;
    top: auto;
    right: 42px;
    bottom: -5px;
    transform: scaleX(-1) !important;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
  }

  .bg-glow {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    width: 130px;
    height: 130px;
    border-radius: 130px;
    z-index: -1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 0);
    box-shadow: 0px 0px 70px 20px rgba(255, 255, 255, 1);
  }
}

.member-details {
  text-align: center;
  margin-bottom: 80px;
  max-width: 100%;

  header {
    h3 {
      font-family: "angelique_roseregular";
      color: white;
      font-size: 2.5rem;
      line-height: 2.2rem;
      margin: 6px auto 10px auto;
      text-align: center;
      word-spacing: -3px;
      padding: 0;
      //max-width: 300px;

      @media screen and (max-width: 1200px) {
        //font-size: 2.2rem;
      }
    }

    h4 {
      font-size: 1.6rem;
      text-transform: uppercase;

      strong {
        color: #09227e;
      }
    }
  }

  p {
    font-size: 1.1rem;

    + p {
      margin-top: 2rem;
    }
  }
}

.other-members {
  position: relative;
  z-index: 2;
  width: 100%;
}

.others-header {
  text-align: center;

  > h1 {
    font-family: "angelique_roseregular";
    font-size: 4.4rem;
    color: white;

    @media screen and (max-width: 768px) {
      font-size: 3rem;
    }
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 3rem;
  }
}

.other-members .VueCarousel-wrapper {
  width: 100%;
  min-height: 320px;
  overflow: visible;

  @media screen and (max-width: 768px) {
    min-height: auto;
  }
}

.other-members .VueCarousel-dot .VueCarousel-dot-inner {
  border-radius: 50% !important;
  box-shadow: none;
}

.other-members-wrapper {
  @media screen and (min-width: 1261px) {
    left: -60px;
  }

  padding-bottom: 590px;
  position: relative;

  //@media screen and (max-width: 768px) {
  //@media screen and (max-width: 1239px) {
  @media screen and (max-width: 1260px) {
    max-width: 65%;
    margin: 0 auto;
    padding: 0 25px 20px 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 1100px) {
    max-width: 75%;
  }

  @media screen and (max-width: 900px) {
    max-width: 75%;
    padding-bottom: 50px;
  }

  @media screen and (max-width: 320px) {
    margin-top: -40px;
  }

  .info-popover-header h5 {
    white-space: normal;
    word-wrap: normal;
    word-break: break-word;
    line-height: 0.75em;
    margin: 5px 0 5px 0;
  }
}

.member-avatar-wrapper {
  width: 100%;
  height: 100%;

  .rounded-image-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 50%;
    position: relative;

    //background-color: #c1552f;
    background-color: #ffffff;

    //rounded-image-wrapper

    img {
      position: absolute;
      width: 100%;
      bottom: 0;
    }
  }

  &:after {
    box-sizing: initial;
    padding: 6px;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    border-radius: 50%;
    border: 3px solid #09227e;
    z-index: -1;
    transform: translate(-50%, -50%) scale(0.7);
    transition: transform 0.2s ease;
    backface-visibility: hidden;
  }

  &:hover:after {
    transform: translate(-50%, -50%) scale(1);
  }
}

.info-popover {
  width: 278px;
  position: absolute;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  &:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(22, 39, 124, 0);
    border-top-color: #16277c;
    border-width: 12px;
    margin-left: -12px;
  }
}

.info-popover-content {
  padding: 26px 33px;
  background-color: #14267b;
}

.info-popover-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  left: -5px;
  bottom: -5px;
  background-color: rgba(0, 0, 0, 0.12);

  &:after {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: transparent;
    border-top-color: rgba(0, 0, 0, 0.12);
    border-width: 12px;
    margin-left: -12px;
  }
}

.info-popover-header {
  h6 {
    font-size: 1.1rem;
    text-transform: uppercase;

    strong {
      color: white;
    }
  }

  h5 {
    color: #ff7c4e;
    font-size: 2.3rem;
    margin-bottom: -0.2rem;
    font-family: "angelique_roseregular";
    white-space: nowrap;
  }
}

.info-popover-desc {
  p,
  strong {
    color: white;
  }
}

.join-the-team {
  width: 100%;
  display: flex;
  justify-content: center;

  .jtt-inner {
    position: relative;

    h1 {
      font-size: 4rem;
      text-transform: uppercase;

      @media screen and (max-width: 768px) {
        font-size: 2rem;
      }

      @media screen and (max-width: 430px) {
        font-size: 1.5rem;
      }

      strong {
        color: white;
      }
    }

    &:before {
      content: "";
      width: 45px;
      height: 52px;
      display: block;
      position: absolute;
      top: 12px;
      left: -64px;
      background-image: url("../.././assets/arrow-3.png");
      background-repeat: no-repeat;
      background-size: 100%;

      @media screen and (max-width: 768px) {
        top: -28px;
        left: -48px;
      }
    }

    .get-in-touch {
      position: absolute;
      right: -44px;
      bottom: -38px;

      h4 {
        color: white;
        font-size: 3rem;
        font-family: "angelique_roseregular";

        @media screen and (max-width: 768px) {
          font-size: 2.5rem;
        }

        @media screen and (max-width: 430px) {
          font-size: 2rem;
        }
      }

      &:after {
        content: "";
        width: 45px;
        height: 52px;
        display: block;
        position: absolute;
        top: -18px;
        right: -38px;
        background-image: url("../.././assets/arrow-1.png");
        background-repeat: no-repeat;
        background-size: 100%;

        @media screen and (max-width: 768px) {
          top: -3px;
          right: -8px;
        }
      }

      &:before {
        content: "";
        width: 37px;
        height: 28px;
        display: block;
        position: absolute;
        top: 32px;
        left: -46px;
        background-image: url("../.././assets/arrow-2.png");
        background-repeat: no-repeat;
        background-size: 100%;

        @media screen and (max-width: 768px) {
          top: 29px;
          left: 23px;
        }
      }
    }
  }
}

.pcb-dots {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;

  .pcb-dot {
    width: 10px;
    height: 10px;
    margin-left: -5px;
    margin-top: -5px;
    position: absolute;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 4px #fff;
    opacity: 0.9;
  }
}

.outer-glow {
  opacity: 1;
  visibility: visible;
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 112%;
  border-radius: 0;
  border-bottom-left-radius: 254px;
  border-bottom-right-radius: 254px;
  z-index: 9999;
  left: 50%;
  top: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border: none;
  background: transparent;
  border-bottom: 26px solid rgb(255, 124, 78);
  //border-bottom: 22px solid green;
  margin-top: 3px;
}

.outer-glow-2 {
  opacity: 1;
  visibility: visible;
  position: absolute;
  overflow: hidden;
  width: 112%;
  height: 112%;
  border-radius: 0;
  border-bottom-left-radius: 254px;
  border-bottom-right-radius: 254px;
  z-index: 9999;
  left: 50%;
  top: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border: none;
  background: transparent;
  border-bottom: 7px solid rgb(238, 113, 70);
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/Team.vue